export const stats = [
  { label: "Happy Customers", value: "50,000+", icon: "ri-user-smile-line" },
  { label: "Insurance Plans Compared", value: "10,000+", icon: "ri-file-list-3-line" },
  { label: "Claims Assisted", value: "8,500+", icon: "ri-shield-check-line" },
  { label: "Expert Advisors", value: "200+", icon: "ri-customer-service-2-line" },
  { label: "Cities Covered", value: "150+", icon: "ri-map-pin-line" },
  { label: "Claim Settlement Rate", value: "97.8%", icon: "ri-percent-line" },
];

export const trustSignals = [
  {
    title: "Expert Advisors",
    description: "Certified insurance and financial advisors with 10+ years of experience guiding you to the right decisions.",
    icon: "ri-user-star-line",
  },
  {
    title: "Transparent Advice",
    description: "No hidden commissions or biased recommendations. We disclose everything upfront so you can make informed choices.",
    icon: "ri-eye-line",
  },
  {
    title: "Lifetime Claims Support",
    description: "Our relationship doesn't end at purchase. We stand by you during claims with dedicated support till settlement.",
    icon: "ri-lifebuoy-line",
  },
  {
    title: "Bank-Grade Security",
    description: "Your personal and financial data is encrypted and protected with industry-standard security protocols.",
    icon: "ri-lock-2-line",
  },
  {
    title: "Fast Response Time",
    description: "Get responses within 15 minutes during business hours. Emergency queries handled on priority.",
    icon: "ri-flashlight-line",
  },
  {
    title: "Personalized Plans",
    description: "Every recommendation is tailored to your age, income, family size, health history, and financial goals.",
    icon: "ri-slideshow-3-line",
  },
];